export enum AuthProvider {
  Google = 'Google',
  Facebook = 'Facebook',
  Amazon = 'LoginWithAmazon',
  Apple = 'SignInWithApple',
  OIDC = 'OIDC',
}
